import React from 'react';

import {BaseMatchModel} from "../../../../../core/components/router/models/base-match-model";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {CompetitorStandingsPageController} from "../competitor.standings-page.controller";
import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {StandingsWidgetAsync} from "../../../../../widgets/standings-widget/components/standings-widget.async";
import {ENTITY_SCORES} from "../../../../../widgets/entity-scores-widget/entity-scores-widget.consts";
import {APP, DBA, ENTITY_TYPES} from "../../../../../core/app/consts";
import {useLocation} from "react-router-dom";
import {BracketsWidgetAsync} from "../../../../../widgets/brackets-widget/components/brackets-widget.async";
import classNames from "classnames";
import styles from "../styles/competitor-standings-page.module.scss";
import {OddsByWidgetAsync} from "../../../../../widgets/odds-by-widget/components/odds-by-widget.async";

export class CompetitorStandingsPageComponentProps extends BaseModuleProps {
  match: BaseMatchModel;
}

export const CompetitorStandingsPageComponent = ({controller, match}) => {
  const location = useLocation();

  const {state, device} = controller;
  const {competitorId, isBrackets} = state;
  const {isSmallView} = device;

  const widgetProps = {
    competitionIds: [location.state?.selectedCompetitionId],
    isSmallView,
    location,
    competitorId,
    onRenderComplete: () => controller.onRenderComplete(),
    context: ENTITY_SCORES.TYPES.competitor,
    dbaPage: DBA.PAGE.competitor,
    source: APP.ANALYTICS.SOURCES.standings
  }

  const oddsByWidgetProps = {
    entityId: competitorId,
    entityType: ENTITY_TYPES.team,
    className: classNames(styles.odds_by, {[styles.small_view]: isSmallView})
  }

  return (
    <>
      {!isBrackets ? <OddsByWidgetAsync {...oddsByWidgetProps} /> : null}
      {isBrackets ? <BracketsWidgetAsync {...widgetProps}/> : <StandingsWidgetAsync {...widgetProps}/>}
    </>
  )
};

const settings: ComposeSettings = {
  component: CompetitorStandingsPageComponent,

  observe: true,
  createModule: true,
  useMetadata: true,

  propsType: CompetitorStandingsPageComponentProps,
  controllerType: CompetitorStandingsPageController,
};

export const CompetitorStandingsPage = Compose(settings);

export default CompetitorStandingsPage;
